<script setup>
defineProps({
  advantages: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>

<template>
  <ul
    v-if="advantages"
    :class="[
      'm-0 p-0 insurance-program__advantages',
      backgroundColor === 'black' ? 'white' : 'black',
    ]"
  >
    <li
      v-for="advantage in advantages"
      :key="advantage.number"
      class="m-0 insurance-program__advantage"
    >
      <p
        v-if="advantage.number"
        class="insurance-program__advantage-number h6-mobile"
        v-html="advantage.number"
      ></p>
      <div
        v-if="advantage.description"
        class="insurance-program__advantage-text body-3-regular"
        v-html="advantage.description"
      ></div>
    </li>
  </ul>
</template>
<style scoped lang="scss">
.insurance-program {
  &__advantages {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    list-style: none;
    @include media-breakpoint-up(sm) {
      gap: 40px;
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 40);
    }
  }
  &__advantage {
    display: flex;
    flex-direction: column;
    gap: 9px;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 9);
    }
    &-number {
      margin: 0;
    }
    &-text {
      &:deep(p:first-child) {
        margin: 0;
      }
    }
  }
}
</style>
